module.exports = __webpack_public_path__ + "static/media/add-circle-outline.8b99890c.svg";